module.exports = __webpack_public_path__ + "static/media/tid.d5ae0e33.svg";